<template>
  <div class="back-wrapper">
  </div>
</template>

<script>
import { TweenMax } from "gsap/TweenMax";
import $ from "jquery";
import completeLoad from '../mixins/completeLoad'

export default {
  data () {
    return {
      next: null,
      imgKey: this.key,
      animation: null,
      backgroundPosition: ''
    }
  },

  mounted () {
    $(window).on('mousemove', (e) => {
      if ($(window).width() > 1024) {
        var x = 1 * e.pageX / $(window).width() * 7 + 50
        var y = 1 * e.pageY / $(window).height() * 7 + 50
        this.backgroundPosition = x + "% " + y + "%"
        $(this.$el).find('.old, .new').css("background-position", this.backgroundPosition)
      }
    })
  },

  mixins: [completeLoad],

  computed: {
    background () {
     return this.$store.state.background
    }
  },

  methods: {
    hideImg () {
      let old = $(this.$el).find('.old')
      let self = this
      TweenMax.to(old, 1, { opacity: 0, ease: Power1.easeInOut, onComplete: function (arg) {
        $(old).remove()
      }})
    },

    append (src, style) {
      $(this.$el).append('<div class="new" style="background-image: url(' + src + '); background-position: ' + this.backgroundPosition + '; ' + style + '"></div>')
    },

    fadeImg (src) {
     this.append(src, 'opacity: 0; top: 0%;')

      var img = $(this.$el).find('.new')
      var old = $(this.$el).find('.old')

      TweenMax.to(img, 1, { opacity: 1, ease: Power1.easeInOut, onComplete: function () {
        $(this.target).removeClass('new').addClass('old')
        $(old).remove()
      }})

      TweenMax.to(old, 1, { opacity: 0, ease: Power1.easeInOut })
    },

    nextImg (src) {
      this.anim(src, '100%', '-100%')
    },

    prevImg (src) {
      this.anim(src, '-100%', '100%')
    },

    anim (src, newFrom, oldTo) {
      this.append(src, 'top: ' + newFrom)

      var img = $(this.$el).find('.new')
      var old = $(this.$el).find('.old')

      TweenMax.to(img, 1, { top: 0, ease: Power3.easeInOut, onComplete: function () {
        $(this.target).removeClass('new').addClass('old')
        $(old).remove()
      }})

      TweenMax.to(old, 1, { top: oldTo, delay: 0.3, ease: Power1.easeInOut })
    }
  },

  watch: {
    background (val) {
      let src = val.src
      let dir = val.dir

      if ($(window).width() < 992) {
        dir = 'fade'
      }

      if (!src) {
        this.hideImg()
        return;
      }

      this[dir + 'Img'](src, dir)
    }
  }
}
</script>

<style lang="scss">
.back-wrapper {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  .old, .new {
    position: absolute;
    background-position: center;
    background-size: 105%;
    left: 0%;
    right: 0%;
    margin: auto;
    height: 100%;
    @media (max-width: 1124px) {
      background-size: cover;
      // -webkit-filter: blur(5px);
      // -moz-filter: blur(5px);
      // -o-filter: blur(5px);
      // -ms-filter: blur(5px);
      // filter: blur(5px);
    }

    // @media (min-height: 1100px) and (min-width: 1200px) {
    //   background-size: cover;
    // }
  }
  .old {
    top: 0%;
    opacity: 1;
  }
}
</style>